import {FormLabelBannerEnum, FormLabelMechanicalEnum, FormLabelMechanicalGroupEnum, FormLabelTitleEnum} from "../Types";

export const getFormLabelMechanicalEnumFromGroup = (group: FormLabelMechanicalGroupEnum): FormLabelMechanicalEnum[] => {
  switch (group) {
    case FormLabelMechanicalGroupEnum.BRI:
      return [
        FormLabelMechanicalEnum.BRI_AMOUNT,
        FormLabelMechanicalEnum.BRI_PERCENT,
      ];
    case FormLabelMechanicalGroupEnum.LOT:
      return [
        FormLabelMechanicalEnum.LOT_TWO_PLUS_ONE,
        FormLabelMechanicalEnum.LOT_THREE_PLUS_ONE,
        FormLabelMechanicalEnum.LOT_FOUR_PLUS_ONE,
      ];
    case FormLabelMechanicalGroupEnum.SPECIAL:
      return [
        FormLabelMechanicalEnum.SPECIAL_ROUND,
        FormLabelMechanicalEnum.SPECIAL_ALL_OFF_EURO,
        FormLabelMechanicalEnum.SPECIAL_ALL_OFF_PERCENT,
        FormLabelMechanicalEnum.SPECIAL_GIFT,
      ];
    case FormLabelMechanicalGroupEnum.RANGE:
      return [
        FormLabelMechanicalEnum.RANGE_AMOUNT,
        FormLabelMechanicalEnum.RANGE_PERCENT,
      ];
    case FormLabelMechanicalGroupEnum.BRAND:
      return [
        FormLabelMechanicalEnum.BRAND_AMOUNT,
        FormLabelMechanicalEnum.BRAND_PERCENT,
      ];
    case FormLabelMechanicalGroupEnum.VOLUME:
      return [
        FormLabelMechanicalEnum.VOLUME_IDENTICAL_PERCENT_SECOND_PRODUCT,
        FormLabelMechanicalEnum.VOLUME_IDENTICAL_PERCENT_THIRD_PRODUCT,
        FormLabelMechanicalEnum.VOLUME_DIFFERENT_PERCENT_SECOND_PRODUCT,
        FormLabelMechanicalEnum.VOLUME_DIFFERENT_PERCENT_THIRD_PRODUCT,
        FormLabelMechanicalEnum.VOLUME_SAME_RANGE_PERCENT_SECOND_PRODUCT,
        FormLabelMechanicalEnum.VOLUME_SAME_RANGE_PERCENT_THIRD_PRODUCT,
      ];
  }
}

export const hasOldPriceField = (mechanical: FormLabelMechanicalEnum): boolean => {
  return [
    ...getFormLabelMechanicalEnumFromGroup(FormLabelMechanicalGroupEnum.BRI),
    ...getFormLabelMechanicalEnumFromGroup(FormLabelMechanicalGroupEnum.LOT),
    FormLabelMechanicalEnum.SPECIAL_ROUND,
    FormLabelMechanicalEnum.SPECIAL_ALL_OFF_EURO,
    FormLabelMechanicalEnum.SPECIAL_ALL_OFF_PERCENT,
  ].includes(mechanical);
}

export const hasDiscountField = (mechanical: FormLabelMechanicalEnum): boolean => {
  return isDiscountEuro(mechanical) || isDiscountPercent(mechanical);
}

export const hasDiscountPrecision = (mechanical: FormLabelMechanicalEnum): boolean => {
  return [
    FormLabelMechanicalEnum.SPECIAL_GIFT
  ].includes(mechanical);
}

export const isOldPriceEuro = (mechanical: FormLabelMechanicalEnum): boolean => {
  return !isOldPricePercent(mechanical);
}

export const isOldPricePercent = (mechanical: FormLabelMechanicalEnum): boolean => {
  return [
    FormLabelMechanicalEnum.SPECIAL_ALL_OFF_PERCENT,
  ].includes(mechanical);
}

export const isDiscountEuro = (mechanical: FormLabelMechanicalEnum): boolean => {
  return [
    FormLabelMechanicalEnum.BRI_AMOUNT,
    FormLabelMechanicalEnum.RANGE_AMOUNT,
    FormLabelMechanicalEnum.BRAND_AMOUNT,
  ].includes(mechanical);
}

export const isDiscountPercent = (mechanical: FormLabelMechanicalEnum): boolean => {
  return [
    FormLabelMechanicalEnum.BRI_PERCENT,
    FormLabelMechanicalEnum.RANGE_PERCENT,
    FormLabelMechanicalEnum.BRAND_PERCENT,
    FormLabelMechanicalEnum.VOLUME_IDENTICAL_PERCENT_SECOND_PRODUCT,
    FormLabelMechanicalEnum.VOLUME_IDENTICAL_PERCENT_THIRD_PRODUCT,
    FormLabelMechanicalEnum.VOLUME_DIFFERENT_PERCENT_SECOND_PRODUCT,
    FormLabelMechanicalEnum.VOLUME_DIFFERENT_PERCENT_THIRD_PRODUCT,
    FormLabelMechanicalEnum.VOLUME_SAME_RANGE_PERCENT_SECOND_PRODUCT,
    FormLabelMechanicalEnum.VOLUME_SAME_RANGE_PERCENT_THIRD_PRODUCT,
  ].includes(mechanical);
}

export const hasScanField = (mechanical: FormLabelMechanicalEnum): boolean => {
  return [
    ...getFormLabelMechanicalEnumFromGroup(FormLabelMechanicalGroupEnum.BRI),
    ...getFormLabelMechanicalEnumFromGroup(FormLabelMechanicalGroupEnum.LOT),
    FormLabelMechanicalEnum.SPECIAL_ROUND,
  ].includes(mechanical);
}

export const getDefaultTitleValue = (mechanical: FormLabelMechanicalEnum): FormLabelTitleEnum => {
  const availableTitles = getAvailableTitles(mechanical);

  return availableTitles[0];
}

export const getAvailableTitles = (mechanical: FormLabelMechanicalEnum): FormLabelTitleEnum[] => {
  switch (mechanical) {
    case FormLabelMechanicalEnum.BRI_AMOUNT:
    case FormLabelMechanicalEnum.BRI_PERCENT:
      return [
        FormLabelTitleEnum.DISCOUNT,
        FormLabelTitleEnum.IMMEDIATE_DISCOUNT,
        FormLabelTitleEnum.UNBEATABLE,
        FormLabelTitleEnum.OFFER_OF_MONTH,
        FormLabelTitleEnum.OFFER_OF_SEASON,
        FormLabelTitleEnum.ANTI_WASTE,
      ];
    case FormLabelMechanicalEnum.LOT_TWO_PLUS_ONE:
      return [
        FormLabelTitleEnum.BUY_TWO_GET_ONE_FREE,
      ];
    case FormLabelMechanicalEnum.LOT_THREE_PLUS_ONE:
      return [
        FormLabelTitleEnum.BUY_THREE_GET_ONE_FREE,
      ];
    case FormLabelMechanicalEnum.LOT_FOUR_PLUS_ONE:
      return [
        FormLabelTitleEnum.BUY_FOUR_GET_ONE_FREE,
      ];
    case FormLabelMechanicalEnum.SPECIAL_ROUND:
      return [
        FormLabelTitleEnum.PRICE_ROUND,
        FormLabelTitleEnum.PRICE_DECREASE,
      ];
    case FormLabelMechanicalEnum.SPECIAL_ALL_OFF_EURO:
    case FormLabelMechanicalEnum.SPECIAL_ALL_OFF_PERCENT:
      return [
        FormLabelTitleEnum.DISCOUNT,
      ];
    case FormLabelMechanicalEnum.SPECIAL_GIFT:
      return [
        FormLabelTitleEnum.GIFT,
      ];
    case FormLabelMechanicalEnum.RANGE_AMOUNT:
    case FormLabelMechanicalEnum.RANGE_PERCENT:
    case FormLabelMechanicalEnum.BRAND_AMOUNT:
    case FormLabelMechanicalEnum.BRAND_PERCENT:
    case FormLabelMechanicalEnum.VOLUME_IDENTICAL_PERCENT_SECOND_PRODUCT:
    case FormLabelMechanicalEnum.VOLUME_IDENTICAL_PERCENT_THIRD_PRODUCT:
    case FormLabelMechanicalEnum.VOLUME_DIFFERENT_PERCENT_SECOND_PRODUCT:
    case FormLabelMechanicalEnum.VOLUME_DIFFERENT_PERCENT_THIRD_PRODUCT:
    case FormLabelMechanicalEnum.VOLUME_SAME_RANGE_PERCENT_SECOND_PRODUCT:
    case FormLabelMechanicalEnum.VOLUME_SAME_RANGE_PERCENT_THIRD_PRODUCT:
      return [
        FormLabelTitleEnum.DISCOUNT,
        FormLabelTitleEnum.UNBEATABLE,
        FormLabelTitleEnum.DISCOUNT_OF_MONTH,
        FormLabelTitleEnum.OFFER_OF_MONTH,
      ];
    default:
      return Object.entries(FormLabelTitleEnum).filter(
        ([key, value]) => ![
          FormLabelTitleEnum.BUY_TWO_GET_ONE_FREE,
          FormLabelTitleEnum.BUY_THREE_GET_ONE_FREE,
          FormLabelTitleEnum.BUY_FOUR_GET_ONE_FREE,
          FormLabelTitleEnum.GIFT,
          FormLabelTitleEnum.PRICE_ROUND,
        ].includes(value)
      ).map(([key, value]) => value);
  }
}

export const getAvailableBanners = (mechanical: FormLabelMechanicalEnum): FormLabelBannerEnum[] => {
  return Object.values(FormLabelBannerEnum);
}
